var ENGINE = ENGINE || {};

/**
 * 状態管理
 *
*/
ENGINE.store = ENGINE.store || {};

ENGINE.store.navigationOpend     = false;
ENGINE.store.navigationAnimation = false;

ENGINE.store.$body = $('body');


/**
 * bodyのスクロールを固定する
 *
*/
ENGINE.noneScroll = {
  position: false,
  $window: $(window),
  $body: $('body'),
  set: function() {
    this.position = this.$window.scrollTop();
    this.$body
    .addClass('BODY_FIXED')
    .css({
      position: 'fixed',
      width: '100%',
      height: '100%',
      overflowX: 'hidden',
      overflowY: 'scroll',
      top: Math.abs(this.position) * -1
    });
  },
  unset: function() {
    if(this.position === false) return false;
    this.$body
    .removeClass('BODY_FIXED')
    .css({
      position: '',
      width: '',
      height: '',
      overflowX: '',
      overflowY: '',
      top: ''
    });

    this.$window.scrollTop(Math.abs(this.position));
    this.position = false;
  },
};


/**
* スムーススクロール
*/
ENGINE.smoothScroll = {
  init: function() {
    $('body a[href^="#"]:not(".js_anchor__exclude")').on('click', function (e) {
      // スクロールの速度
      var speed = 400;
      // アンカーの値取得
      var href = $(this).attr("href");
      // 移動先を取得
      var target = $(href);
      // Headerの高さ取得
      var headerHeight = $('header').outerHeight();
      // 移動先を数値で取得
      var headerPos = target.offset().top - headerHeight;
    
      e.preventDefault();
    
      $('body,html').animate({
        scrollTop: headerPos
      }, speed, 'swing');
      return false;
    });
  },
}


/**
 * オブジェクトの監視
 *
*/
ENGINE.effect = {
  init: function() {
    const options = {
      // threshold: 0.5,
      // threshold: [0, 0.2, 0.4, 0.6, 0.8, 1.0],
      threshold: [0, 0.5],
    };

    const callback = function(entries, observer) {
      entries.forEach(entry => {
        const el = entry.target;

        if(entry.intersectionRatio) {
          // ready状態のターゲットであればアニメーション実行用のクラスを付与する
          if(el.classList.contains('ready')) {
            el.classList.add('entry');
          }

          // 一度画面内に現れた要素は監視を終了
          observer.unobserve(el);
        } else {

          // 初回発火時に画面外に要素にはアニメーション準備のクラスを付与する
          el.classList.add('ready');
        }
      });
    }

    this.observer = new IntersectionObserver(callback, options);
    const node = document.querySelectorAll('.js_effect');
    this.elements = Array.prototype.slice.call(node);
    this.start();
  },

  start: function() {
    this.elements.forEach(el => this.observer.observe(el));
  },

  stop: function() {
    this.elements.forEach(el => this.observer.unobserve(el));

  }
}


ENGINE.matchMedia = {
  init: function() {
    window.matchMedia('screen and (max-width:768px)').addListener( function(e) {
      $(window).trigger('MATCH_MEDIA_EXCHANGE');
      $(window).trigger('MATCH_MEDIA_768');
      if(!e.matches) {
        $(window).trigger('MATCH_MEDIA_768_OVER');
      } else {
        $(window).trigger('MATCH_MEDIA_768_UNDER');
      }
    });

    var user_agent = window.navigator.userAgent.toLowerCase();
    var is_IE11 = (user_agent.indexOf('trident/7') >= 0)?true:false;
    if (is_IE11) {
      $('body').addClass('is_IE11');
      if (user_agent.match(/windows nt [0-9]\.[0-9]/i)) {
        $('body').addClass('is_old_windows');
      }
    }
  }
}


ENGINE.viewContent = {
  init: function() {
    $(window).on('scroll', () => {
      const pos = $(window).scrollTop();
      if(pos > 100) {
        $('body').addClass('VIEW_CONTENTS');
      } else {
        $('body').removeClass('VIEW_CONTENTS');
      }
    })
  }
}


ENGINE.lazyload = {
  init: function() {
    var lazyLoadInstance = new LazyLoad({
      elements_selector: ".js_lazy",
    });
  }
}

/**
* Slide Toggle
*/
ENGINE.slideToggle= {
  init: function() {
    $('.js_slideToggle button').on('click', function() {
      $(this).parent().find('dd').slideToggle();
      if($(this).hasClass('is_open')){
        $(this).removeClass('is_open');
        $(this).text('READ MORE');
      } else{
        $(this).addClass('is_open');
        $(this).text('CLOSE');
      }
    });
  }
}

/**
*  スクロールイン
*/
ENGINE.scrollIn = {
  init: function() {
    $(window).scroll(function() {
      $('.js_scrollIn:not(.is_scrollIn)').each(function() {
        const elemPos = $(this).offset().top;
        const scroll = $(window).scrollTop();
        const windowHeight = $(window).height();
        if (scroll > elemPos - windowHeight + 150) {
          $(this).addClass('is_scrollIn');
        }
      });
    });
    $(window).scroll();
  },
}


/**
*  一定Scroll時にエントリーボタンを固定
*/
ENGINE.fixed = {
  init: function() {
    var fixed = $('.js_fixed');

    fixed.hide();

    $(window).scroll(function () {
      // スクロールが500に達したらボタン表示
      if ($(this).scrollTop() > 300) {
        fixed.fadeIn();
        $(fixed).addClass('is_fixed');
      } else {
        fixed.fadeOut();
        $(fixed).removeClass('is_fixed');
      }
    });
  },
}


/**
* 発火用
*/
window.addEventListener('DOMContentLoaded', function() {

  ENGINE.viewContent.init();

  ENGINE.smoothScroll.init();

  ENGINE.slideToggle.init();

  ENGINE.matchMedia.init();

  ENGINE.lazyload.init();

  ENGINE.effect.init();

  ENGINE.scrollIn.init();

  ENGINE.fixed.init();

});